
export async function fetchAdScheduleXml(scheduleUrl: string): Promise<string> {
  const response = await fetch(scheduleUrl, { credentials: 'omit' });
  if (!response.ok) {
    throw new Error(`Ad schedule fetch failed (${response.status}): ${scheduleUrl}`);
  }
  return response.text();
}
